import { Typography } from "@mui/material";

export default function ReportsHelp() {
  return (
    <>
      <Typography variant="body1" gutterBottom>
        Reports help
      </Typography>
    </>
  );
}
